export default "__VITE_PUBLIC_ASSET__914e3c91__"